import { Button, Dialog, DialogTitle } from "@mui/material";
import { motion } from "framer-motion";
import {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { useLocation } from "react-router-dom";
import ChartsHandler from "../../../components/Charts/ChartsHandler.tsx";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import FiltroV2 from "../../../components/FiltroV2/FiltroV2";
import FiltrosRedux from "../../../contexts/Filtros.js";
import MultiplosFiltrosRedux from "../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import { useToast } from "../../../contexts/ToastContext.tsx";
import Icon from "../../../core/components/Icon.tsx";
import MotionContainer from "../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import RenderCsvLink from "../../../core/components/RenderCsvLink.tsx";
import Separator from "../../../core/components/Separator.tsx";
import Layout from "../../../core/layout/Layout.tsx";
import {
	primeiroDiaDosMesFormatado,
	ultimoDiaDosMesFormatado,
} from "../../../core/utils/UtilityDates.ts";
import {
	editaMeta,
	getMetaContexto,
} from "../../../services/ModuloGerenciador/Relatorio";
import { getFaturamento } from "../../../services/ModuloGerenciador/Search";
import TabelaEmbarqueVirtualizada from "../Embarque/components/TabelaEmbarqueVirtualizada.tsx";
import "./Faturamento.css";

const itensFiltro = [
	{
		nomeColuna: "Tipo Carroceria",
		field: "tipoCarroceria",
	},
	{
		nomeColuna: "Descrição",
		field: "descricao",
	},
	{
		nomeColuna: "Empresa",
		field: "empresa",
	},
	{
		nomeColuna: "Filial",
		field: "filial",
	},
	{
		nomeColuna: "Unidade de Embarque",
		field: "unidEmbarque",
	},
	{
		nomeColuna: "Cidade Origem",
		field: "cidadeOrigem",
	},
	{
		nomeColuna: "Estado Origem",
		field: "estadoOrigem",
	},
	{
		nomeColuna: "Cidade Destino",
		field: "cidadeDestino",
	},
	{
		nomeColuna: "Estado Destino",
		field: "estadoDestino",
	},
	{
		nomeColuna: "Pedido",
		field: "pedido",
	},
	{
		nomeColuna: "CTE",
		field: "cte",
	},
	{
		nomeColuna: "Previsão Viagem",
		field: "previsaoEmbarque",
	},
	{
		nomeColuna: "Data Viagem",
		field: "dataEmbarque",
	},
	{
		nomeColuna: "Previsão Entrega",
		field: "previsaoEntrega",
	},
	{
		nomeColuna: "Data Entrega",
		field: "dataEntrega",
	},
	{
		nomeColuna: "Data Hora Chegada Viagem",
		field: "dataHoraChegadaEmbarque",
	},
	{
		nomeColuna: "Data Hora Chegada Entrega",
		field: "dataHoraChegadaEntrega",
	},
	{
		nomeColuna: "Data Hora Entregue",
		field: "dataHoraEntregue",
	},
	{
		nomeColuna: "Data Hora Embarcado",
		field: "dataHoraEmbarcado",
	},
	{
		nomeColuna: "Aceite",
		field: "aceite",
	},
	{
		nomeColuna: "Status",
		field: "status",
	},
	{
		nomeColuna: "Placa Cavalo",
		field: "placaCavalo",
	},
	{
		nomeColuna: "Placa Carreta",
		field: "placaCarreta",
	},
	{
		nomeColuna: "Placa Segunda Carreta",
		field: "placaCarreta2",
	},
	{
		nomeColuna: "Proprietario",
		field: "proprietario",
	},
	{
		nomeColuna: "Motorista",
		field: "veiculoMotorista",
	},
	{
		nomeColuna: "ICMS",
		field: "icms",
	},
	{
		nomeColuna: "Frete Motorista",
		field: "freteMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Frete Fiscal",
		field: "freteFiscal",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Empresa",
		field: "adicionalEmpresa",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Motorista",
		field: "adicionalMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Pedagio",
		field: "pedagio",
		tipo: "number",
	},
	{
		nomeColuna: "Classificação",
		field: "classificacao",
		tipo: "number",
	},
	{
		nomeColuna: "Margem",
		field: "margem",
	},
	{
		nomeColuna: "Adiantamento",
		field: "adiantamento",
		tipo: "number",
	},
	{
		nomeColuna: "Saldo",
		field: "saldo",
		tipo: "number",
	},
	{
		nomeColuna: "Meio Pagamento",
		field: "meioPagamento",
	},
	{
		nomeColuna: "Meio Pagamento Dois",
		field: "meioPagamento2",
	},
	{
		nomeColuna: "Km",
		field: "km",
		tipo: "number",
	},
	{
		nomeColuna: "Cliente",
		field: "cliente",
	},
	{
		nomeColuna: "Embarcador",
		field: "embarcador",
	},
	{
		nomeColuna: "Destinatario",
		field: "destinatario",
	},
	{
		nomeColuna: "LOAD",
		field: "load",
	},
	{
		nomeColuna: "Mercadoria",
		field: "mercadoria",
	},
	{
		nomeColuna: "Peso",
		field: "peso",
		tipo: "number",
	},
	{
		nomeColuna: "Embalagem",
		field: "embalagem",
	},
	{
		nomeColuna: "Observação",
		field: "observacao",
	},
	{
		nomeColuna: "Frota",
		field: "frota",
	},
	{
		nomeColuna: "Cancelado",
		field: "cancelado",
	},
	{
		nomeColuna: "Motivo",
		field: "motivo",
	},
	{
		nomeColuna: "Usuário Responsável",
		field: "usuarioResponsavel",
	},
	{
		nomeColuna: "Elegível BRF",
		field: "elegivelBrf",
	},
];

const headersFaturamento = {
	Faturamento: [
		{
			nomeColuna: "Adiantamento",
			field: "adiantamento",
		},
		{
			nomeColuna: "Adicional Empresa",
			field: "adicionalEmpresa",
		},
		{
			nomeColuna: "Adicional Motorista",
			field: "adicionalMotorista",
		},
		{
			nomeColuna: "Classificação",
			field: "classificacao",
		},
		{
			nomeColuna: "Frete Fiscal",
			field: "freteFiscal",
		},
		{
			nomeColuna: "Frete Motorista",
			field: "freteMotorista",
		},
		{
			nomeColuna: "ICMS",
			field: "icms",
		},
		{
			nomeColuna: "KM",
			field: "km",
		},
		{
			nomeColuna: "Margem",
			field: "margem",
		},
		{
			nomeColuna: "Pedágio",
			field: "pedagio",
		},
		{
			nomeColuna: "Peso",
			field: "peso",
		},
		{
			nomeColuna: "Saldo",
			field: "saldo",
		},
		{
			nomeColuna: "Imposto Federal",
			field: "impostoFederal",
		},
		{
			nomeColuna: "Custo Administrativo",
			field: "custoAdm",
		},
		{
			nomeColuna: "Restituição",
			field: "restituicao",
		},
	],
};

function Faturamento() {
	const { profile, hasRegra, contextoEmbarque } = useProfile();
	const { showToast } = useToast();
	const location = useLocation();

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);
	const { setFiltrosRedux } = useContext(FiltrosRedux);

	const hasBuscadoDadosInicial = useRef(false);
	const tableRecalcRef = useRef(null);

	const [values, setValues] = useState([]);
	const [openFaturamentos, setOpenFaturamentos] = useState(true);
	const [openProjecao, setOpenProjecao] = useState(false);
	const [openTelaCheia, setOpenTelaCheia] = useState(true);
	const [loading, setLoading] = useState(true);
	const [dadosTabela, setDadosTabela] = useState([]);
	const [dadosRelatorio, setDadosRelatorio] = useState([]);
	const [dadosGrafico, setDadosGrafico] = useState([]);
	const [openMetas, setOpenMetas] = useState(false);
	const [valuesPesquisa, setValuesPesquisa] = useState({
		item: undefined,
		pesquisa: undefined,
		contexto: "todos",
		embarqueInicio: primeiroDiaDosMesFormatado,
		embarqueFinal: ultimoDiaDosMesFormatado,
	});
	const [semAutorizacao, setSemAutorizacao] = useState(false);
	const [semAutorizacaoMetas, setSemAutorizacaoMetas] = useState(true);

	const toggleShowFaturamentoBoxes = useCallback(() => {
		setOpenFaturamentos(!openFaturamentos);
	}, [openFaturamentos]);

	const onClickOpenProjecao = () => {
		setOpenProjecao(!openProjecao);
	};

	const onClickTelaCheia = useCallback(() => {
		setOpenFaturamentos(false);
		setOpenTelaCheia(!openTelaCheia);
	}, [openTelaCheia]);

	const handleCloseMetas = useCallback(() => {
		setOpenMetas(false);
	}, []);

	const handleOpenMetas = useCallback(() => {
		setOpenMetas(true);
	}, []);

	const buscarDadosInicial = useCallback(async () => {
		setLoading(true);
		if (profile?.token) {
			await getFaturamento(
				profile?.token,
				"",
				contextoEmbarque === "templateEmbarque" ? "todos" : contextoEmbarque,
				primeiroDiaDosMesFormatado,
				ultimoDiaDosMesFormatado,
			)
				.then((result) => {
					setDadosTabela(result.data.embarques);
					setDadosGrafico(result.data.projecaoFaturamento);
					setDadosRelatorio(result.data.paginaRelatorioValores);
				})
				.catch((error) => {
					if (error?.response?.data) {
						showToast(error.response.data, "error");
						return;
					}
					showToast("Erro ao buscar faturamento", "error");
				});
		}
		setLoading(false);
	}, [profile?.token, showToast, contextoEmbarque]);

	const buscarSearch = useCallback(
		async (ordenarPor) => {
			setLoading(true);
			let dados = [];
			let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
			if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
				for (let filtro of multiplosFiltrosRedux) {
					pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
				}
			}
			if (profile?.token) {
				await getFaturamento(
					profile?.token,
					pesquisaFormatada,
					valuesPesquisa.contexto,
					valuesPesquisa.embarqueInicio,
					valuesPesquisa.embarqueFinal,
					ordenarPor,
				)
					.then((result) => {
						setDadosTabela(result.data.embarques);
						setDadosGrafico(result.data.projecaoFaturamento);
						setDadosRelatorio(result.data.paginaRelatorioValores);
					})
					.catch((error) => {
						if (error?.response?.data) {
							showToast(error.response.data, "error");
							return;
						}
						showToast("Erro ao buscar faturamento", "error");
					});
			}
			setLoading(false);
		},
		[profile?.token, valuesPesquisa, multiplosFiltrosRedux, showToast],
	);

	const buscarMeta = useCallback(async () => {
		setLoading(true);
		if (profile?.token) {
			await getMetaContexto(profile?.token, valuesPesquisa.contexto)
				.then((result) => {
					setValues(result.data);
				})
				.catch((error) => {
					if (error?.response?.data) {
						showToast(error.response.data, "error");
						return;
					}
					showToast("Erro ao buscar metas", "error");
				});
		}
		setLoading(false);
	}, [profile?.token, valuesPesquisa.contexto, showToast]);

	const buscarMetaInicial = useCallback(async () => {
		setLoading(true);
		if (profile?.token) {
			await getMetaContexto(
				profile?.token,
				contextoEmbarque === "templateEmbarque" ? "todos" : contextoEmbarque,
			)
				.then((result) => {
					setValues(result.data);
				})
				.catch((error) => {
					if (error?.response?.data) {
						showToast(error.response.data, "error");
						return;
					}
					showToast("Erro ao buscar metas", "error");
				});
		}
		setLoading(false);
	}, [profile?.token, showToast]);

	const editarMeta = useCallback(async () => {
		setLoading(true);
		await editaMeta(profile?.token, values)
			.then(() => {
				setOpenMetas(false);
				buscarMeta();
				buscarSearch();
			})
			.catch((error) => {
				if (error?.response?.data) {
					showToast(error.response.data, "error");
					return;
				}
				showToast("Erro ao editar metas", "error");
			});
		setLoading(false);
	}, [values, profile?.token, buscarSearch, buscarMeta, showToast]);

	const setValorInicial = useCallback(async () => {
		setValuesPesquisa((current) => ({
			...current,
			contexto: "todos",
			embarqueInicio: primeiroDiaDosMesFormatado,
			embarqueFinal: ultimoDiaDosMesFormatado,
		}));
	}, [primeiroDiaDosMesFormatado, ultimoDiaDosMesFormatado]);

	const limpar = useCallback(async () => {
		setValuesPesquisa([]);
		setValorInicial();
		buscarDadosInicial();
		buscarMetaInicial();
	}, [setValorInicial, buscarDadosInicial, buscarMetaInicial]);

	const buscarOrdenacao = (ordenarPor) => {
		buscarSearch(ordenarPor);
	};

	useEffect(() => {
		setValuesPesquisa((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
		setFiltrosRedux((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
	}, [location.pathname]);

	const isLoading = useMemo(() => {
		return (
			loading ||
			!profile?.token ||
			(!dadosTabela.length && !hasBuscadoDadosInicial.current)
		);
	}, [loading, dadosTabela.length, profile?.token]);

	useEffect(() => {
		if (profile?.token && !hasBuscadoDadosInicial.current) {
			setSemAutorizacao(!hasRegra("Faturamento"));
			setSemAutorizacaoMetas(!hasRegra("Cadastrar Meta"));
			hasBuscadoDadosInicial.current = true;
			buscarDadosInicial();
			buscarMetaInicial();
		}
	}, [profile?.token, hasRegra, buscarDadosInicial, buscarMetaInicial]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title="Faturamento">
			<MotionContainer animationKey="FaturamentoScreen" scroll>
				<div className="content-container-scrollable">
					{!openTelaCheia ? (
						<div className="header-faturamentos">
							<div className="flex2">
								<div className="flex3">
									{!openTelaCheia && (
										<p className="texto-tela-cheia">Modo Tela Cheia Ativo</p>
									)}
								</div>
								<div className="flex3">
									{!openTelaCheia && (
										<div className="icon-div" onClick={onClickTelaCheia}>
											<Icon theme="dark" name="Expand" size="xl" />
										</div>
									)}
								</div>
							</div>
						</div>
					) : (
						<div className="filtro-faturamento">
							<div className="filtro-embarque-v2">
								<FiltroV2
									classe="div-filtrar-faturamento-v2"
									classOption="select-options"
									itensFiltro={itensFiltro}
									valuesPesquisa={valuesPesquisa}
									setValuesPesquisa={setValuesPesquisa}
									buscarSearch={buscarSearch}
									limpar={limpar}
								/>
								<div className="fat-botoes">
									<CustomButtonV2
										classCss="custom-button-faturamento"
										classText="button-texto-faturamento"
										titulo={openProjecao ? "Ocultar Gráfico" : "Exibir Gráfico"}
										cor="#FFFFFF"
										onClick={onClickOpenProjecao}
									/>
									{!semAutorizacaoMetas && (
										<CustomButtonV2
											classCss="custom-button-faturamento"
											classText="button-texto-faturamento"
											titulo="Cadastrar Meta"
											cor="#FFFFFF"
											onClick={handleOpenMetas}
										/>
									)}
									<Separator direction="horizontal" size="sm" />
									<div
										className="icon-div"
										onClick={toggleShowFaturamentoBoxes}
									>
										{openFaturamentos ? (
											<Icon theme="dark" name="Captions" size="2xl" />
										) : (
											<Icon theme="dark" name="CaptionsOff" size="2xl" />
										)}
									</div>

									<Separator direction="horizontal" size="sm" />
									<div className="csv-link">
										<RenderCsvLink classe={"idEmbarque"} lista={dadosTabela} />
									</div>
								</div>
							</div>
							<Separator size="md" />
						</div>
					)}
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							width: "95%",
						}}
					>
						<motion.div
							initial={{
								opacity: 0,
								height: 0,
							}}
							animate={{
								opacity: openFaturamentos ? 1 : 0,
								height: openFaturamentos ? 100 : 0,
							}}
							onAnimationComplete={() => {
								requestAnimationFrame(() => {
									requestAnimationFrame(() => {
										tableRecalcRef.current?.();
									});
								});
							}}
							className="container-faturamento-screen-card"
						>
							{headersFaturamento.Faturamento.map((header) => (
								<div className="card-faturamento" key={header.field}>
									<div className="card-header">{header.nomeColuna}</div>
									<div className="card-body">
										{dadosRelatorio && dadosRelatorio[header.field]
											? dadosRelatorio[header.field].toLocaleString("pt-BR", {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												})
											: "0,00"}
									</div>
								</div>
							))}
						</motion.div>
					</div>
					<Separator size="md" />
					<motion.div
						initial={{ opacity: 0, height: 0 }}
						animate={{
							opacity: openProjecao ? 1 : 0,
							height: openProjecao ? 560 : 0,
						}}
						transition={{
							duration: 0.36,
							opacity: { delay: 0.3, duration: 0.28, ease: "easeInOut" },
							ease: "easeInOut",
						}}
						onAnimationComplete={() => {
							requestAnimationFrame(() => {
								requestAnimationFrame(() => {
									tableRecalcRef.current?.();
								});
							});
						}}
						className="principal-projecao-faturamento"
					>
						<div className="item-projecao">
							{openProjecao && (
								<ChartsHandler
									data={dadosGrafico}
									type="line"
									group
									height={560}
									width={570}
								/>
							)}
						</div>
					</motion.div>
					<TabelaEmbarqueVirtualizada
						dados={dadosTabela}
						buscarOrdenacao={buscarOrdenacao}
						isLoading={isLoading}
						registerRecalc={(fn) => (tableRecalcRef.current = fn)}
						hasFooter={false}
					/>
					<Separator size="md" />
				</div>
				<Dialog
					className="corpoModalMetas"
					open={openMetas}
					onClose={handleCloseMetas}
				>
					<DialogTitle>Meta</DialogTitle>
					<input
						type="number"
						id="apelido"
						className="input-text"
						onChange={(e) => {
							setValues((current) => ({
								...current,
								meta: e.target.value,
							}));
						}}
						value={values.meta}
					/>
					<div className="botaoConcluir">
						<Button
							sx={{ width: 180 }}
							variant="contained"
							onClick={() => {
								editarMeta();
							}}
						>
							Cadastrar
						</Button>
					</div>
				</Dialog>
			</MotionContainer>
		</Layout>
	);
}

export default Faturamento;
